import { createContext } from 'react'

import type { AuthContextValue } from '@/shared/auth/types'

export const AuthContext = createContext<AuthContextValue | null>(null)
